
import * as R from 'ramda';

import {
  getNewsAndEventById,
  getOfferListDataById,
  getStoreById
} from '~/data-utils';

export default class SearchItem {

  constructor (id, type, primary, secondary, ref) {
    this.id = String(id);
    this.type = type;
    this.primary = primary;
    this.secondary = secondary;
    this.ref = ref;

    Object.freeze(this);
  }

  combine (options) {
    const { id, type, primary, secondary, ref } = options;
    return new SearchItem(
      id || this.id,
      type || this.type,
      primary || this.primary,
      secondary || this.secondary,
      ref || this.ref
    );
  }

  merge (item) {

    const uniq = (a, b) => R.uniq([...a, ...b]);

    return SearchItem.of(
      R.mergeWithKey(
        (k, l, r) => /(prima|seconda)ry/.test(k) ? uniq(l,r) : r,
        this, item
      )
    );
    // return new SearchItem(
    //   this.id,
    //   this.type,
    //   R.uniq([...this.primary, item.primary]),
    //   secondary || this.secondary,
    //   ref || this.ref
    // );
  }

  static of ({ id, type, primary, secondary, ref }) {
    return new SearchItem(id, type, primary, secondary, ref);
  }

  // getTypeData :: (SearchItem, IMDApp) -> Store|Offer|Facility
  static getTypeData (item, app) {
    const { type, id } = item;

    const data = resolve(type, id, app);
    if (!data) {
      console.warn(`Unable to get ${type} data for id '${id}'`);
    }
    return data;
  }

}

const resolve = (type, id, app) => {
  switch (type) {
  case 'facility': return app.service().facilities.getFacility(id);
  case 'newsAndEvent': return getNewsAndEventById(id);
  case 'offer': return getOfferListDataById(id);
  case 'store': return getStoreById(id);
  default:
    console.warn(`Missing data resolver for '${type}'`);
    return {};
  }
};
